module.exports = __webpack_public_path__ + "static/media/traktoPromoImg.26ff38a5.png";